module.exports = __webpack_public_path__ + "static/media/telecommunications.473742ef.svg";